import {translate} from '../i18n';


export default class ResponseError {
    /**
     *
     * @param {string?} message
     * @param {{}?} details
     */
    constructor(message, details) {
        this.message = message || null;
        this.details = details || null;
    }

    /**
     *
     * @return {string}
     */
    getMessage() {
        return this.message || translate('Something went wrong');
    }

    /**
     *
     * @return {{}}
     */
    getDetails() {
        return this.details || {};
    }

    /**
     *
     * @return {boolean}
     */
    hasDetails() {
        return Object.keys(this.getDetails()).length > 0;
    }
}
